import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useLang } from './LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const { lang } = useLang();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content`, { params: { lang } });
      setContent(res.data);
    } catch (err) {
      console.error('Failed to load site content:', err);
      setContent({});
    } finally {
      setLoading(false);
    }
  }, [lang]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = (key, fallback) => {
  const ctx = useContext(ContentContext);
  if (!ctx || !ctx.content) return fallback;
  return ctx.content[key] ?? fallback;
};

export const useContentContext = () => useContext(ContentContext);
